import { AutoLogoutDialogComponent } from './auto-logout-dialog/auto-logout-dialog.component';
import { AuthGuard } from './core/services/auth-guard.service';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import {
  VerificationLevelZeroUpdateDialogComponent
} from './profile/verification-level-zero-update-dialog/verification-level-zero-update-dialog.component';
// import { ChatComponent } from './chat/chat.component';
import { ContactSupportComponent } from './contact-support/contact-support.component';
import { MetaGuard } from '@ngx-meta/core';
import { GenericComponent } from './core/responses/generic/generic.component';
import { NotFoundComponent } from './core/responses/not-found/not-found.component';
import { RedirectComponent } from './core/responses/redirect/redirect.component';

import { environment } from '../environments/environment';

import { PreloadService } from './core/services/preload.service';
import { VerificationCallbackComponent } from './profile/verification-callback/verification-callback.component';

export const routes: Routes = [
  {
    path: 'autologoutdialog', component: AutoLogoutDialogComponent, data: {
      title: 'Auto Logout'
    }, canActivate: [AuthGuard, MetaGuard]
  },
  {
    path: 'verificationlevelzeroupdatedialog', component: VerificationLevelZeroUpdateDialogComponent, data: {
      title: 'Verification Level Zero Update'
    }, canActivate: [AuthGuard, MetaGuard]
  },
  {
    path: 'callback/:provider',
    component: VerificationCallbackComponent,
    data: {},
    canActivate: [AuthGuard, MetaGuard]
  },
  { path: 'coins', loadChildren: () =>
    import('./home/coin-landing/coin-landing.module').then(m => m.CoinLandingModule)
  },
  { path: 'dashboard', loadChildren: () =>
    import('./home/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: '', loadChildren: () =>
    import('./request-confirm/request-confirm.module').then(m => m.RequestConfirmModule)
  },
  { path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: '', loadChildren: () => import('./balances/balances.module').then(m => m.BalancesModule) },
  { path: '', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: '', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },
  { path: '', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule) },
  { path: '', loadChildren: () => import('./markets/markets.module').then(m => m.MarketsModule) },
  { path: '', loadChildren: () => import('./info/info.module').then(m => m.InfoModule) },
  // { path: '', loadChildren: () => import('./leader-board/leader-board.module').then(m => m.LeaderBoardModule) },
  // { path: '', loadChildren: () => import('./promotions/pomotions.module').then(m => m.PromotionsModule) },
  { path: 'support', component: ContactSupportComponent,
    data: { meta: {
      title: environment.config.EXCHANGE_NAME + ' - ' + 'Contact Support',
      description: 'Contact ' + environment.config.EXCHANGE_NAME + ' support for account and platform assistance.'
    } },
   canActivate: [ MetaGuard ]},
  { path: '', loadChildren: () => import('./history/history.module').then(m => m.HistoryModule) },
  { path: 'unavailable', loadChildren: () =>
    import('./core/responses/unavailable/unavailable.module').then(m => m.UnavailableModule),
    canActivate: [MetaGuard]
  },
  { path: '', loadChildren: () => import('./referral/referral.module').then(m => m.ReferralModule) },
  { path: '403', redirectTo: 'core/responses/forbidden'},
  { path: '404', component: NotFoundComponent, canActivate: [MetaGuard]},
  { path: 'response/:code', component: GenericComponent, canActivate: [MetaGuard]},
  { path: 'redirect/:url', component: RedirectComponent, canActivate: [MetaGuard]},
  { path: 'redirect', component: RedirectComponent, canActivate: [MetaGuard]},
  { path: 'fergnson', component: RedirectComponent, canActivate: [MetaGuard]},
  { path: '**', redirectTo: '404'}
];

export default routes;
export { RouterModule };
export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadService,
  initialNavigation: 'enabledBlocking',
  onSameUrlNavigation: 'reload',
  anchorScrolling: 'enabled'
});

